import React, { useCallback, useEffect, useState } from "react";
import MyEditor from "../../../components/MyEditor";
import WebLayout from "../../../layout/WebLayout";
import UploadImage from "../../../components/UploadImage";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ProductSpecificationEditor from "../../../components/ProductSpecificationEditor";
import ProductAction from "../../../stores/actions/ProductAction";
import { RootState } from "../../../stores";
import CategoryAction from "../../../stores/actions/categoryAction";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import HSNAction from "../../../stores/actions/HSNAction";
import Select from "react-select";
import GalleryModal from "../../../components/GalleryModal";
import GalleryAction from "../../../stores/actions/GalleryAction";

type FormData = {
  barcode: string;
  description: string;
  selling_price: any;
  tax: number;
  category_id: number;
  sub_category_id: number;
  child_category_id: number;
  is_variant: any;
  product_specification: string;
  product_image: string;
  status: string;
  product_code: any;
};

function ActivateEcomProduct() {
  const dispatch = useDispatch()<any>;
  const navigate = useNavigate();

  const routeParams = useParams();
  const productId = routeParams.id;

  const { hsnList } = useSelector((state: RootState) => state.hsn);
  const { categoryList } = useSelector((state: RootState) => state.category);
  const { subCategoryList } = useSelector((state: RootState) => state.category);
  const { childCategoryList } = useSelector(
    (state: RootState) => state.category,
  );

  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [selectedSubcategory, setSelectedSubcategory] = useState<any>();
  const [selectedOption, setSelectedOption] = useState<any>(null);

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [editorData, setEditorData] = useState<string>("");
  const [specification, setSpecification] = useState<string>("");
  const [image, setImage] = useState<any>([]);
  const [search, setSearch] = useState<any>();
  const [limit, setLimit] = useState<any>(10);
  const [page, setPage] = useState<number>(1);

  const handleEditorChange = (newData: string) => {
    setEditorData(newData);
  };

  const handleProductSpeciEditorChange = (newData: string) => {
    setSpecification(newData);
  };

  const [images, setImages] = useState<File[]>([]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const formHandleSubmit = async (data: any, e: any) => {
    e.preventDefault();
    if (selectedOption === null) {
      toast.error("HSN Code is required");
      return false;
    }

    let img: any = [];

    if (image?.length > 0) {
      image.map((d: any) => img.push(d.id));
    }

    setIsLoader(true);

    try {
      await dispatch(
        ProductAction.addActivateProduct({
          id: Number(productId),
          barcode: data.barcode,
          description: editorData,
          selling_price: data.selling_price,
          tax: selectedOption.value,
          category_id: data.category_id,
          sub_category_id: data.sub_category_id,
          child_category_id: data.child_category_id,
          is_variant: data.is_variant,
          product_specification: specification,
          status: data.status,
          product_image: images,
          gallery: img,
        }),
      );
      setIsLoader(false);
      reset();
      navigate("/product-list");
      toast.success("Product Activated Successfully");
    } catch (error: any) {
      setIsLoader(false);
      toast.error(error.message);
    }
  };

  const getCategoryList = useCallback(async () => {
    await dispatch(
      CategoryAction.getCategory({
        search: "",
        limit: 100,
        offset: 0,
        keyword: "",
        sortBy: "",
        sortType: "",
      }),
    );
  }, [dispatch]);

  const getSubCategoryList = useCallback(async () => {
    await dispatch(
      CategoryAction.getSubCategory({
        search: "",
        limit: 100,
        offset: 0,
        keyword: "",
        sortBy: "",
        sortType: "",
        category: selectedCategory,
        type: "filter",
      }),
    );
  }, [dispatch, selectedCategory]);

  const getChildCategoryList = useCallback(async () => {
    await dispatch(
      CategoryAction.getChildCategory({
        search: "",
        limit: 100,
        offset: 0,
        keyword: "",
        sortBy: "",
        sortType: "",
        sub_category: selectedSubcategory,
        type: "filter",
      }),
    );
  }, [dispatch, selectedSubcategory]);

  const getHSNList = useCallback(async () => {
    await dispatch(HSNAction.getList());
  }, [dispatch, selectedSubcategory]);

  const getGallery = useCallback(async () => {
    await dispatch(
      GalleryAction.getGallery({
        limit: limit,
        search: search,
        page: page,
      }),
    );
  }, [dispatch, search]);

  useEffect(() => {
    getHSNList();
    getCategoryList();
    getSubCategoryList();
    getChildCategoryList();
    getGallery();
  }, [
    getHSNList,
    getCategoryList,
    getSubCategoryList,
    getChildCategoryList,
    selectedCategory,
    selectedSubcategory,
    getGallery,
  ]);

  const handleCategoryChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setSelectedCategory(Number(event.target.value));
    setSelectedSubcategory(null);
  };

  const handleSubcategoryChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setSelectedSubcategory(Number(event.target.value));
  };

  const handleChange = (value: any) => {
    setSelectedOption(value);
  };

  const removeImage = (id: number) => {
    const data = [...image];
    const findIndex = data.findIndex((d) => d.id === id);

    if (findIndex > -1) {
      data.splice(findIndex, 1);
    }
    setImage(data);
  };

  return (
    <WebLayout pageName={"ActivateEcomProduct"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="app-ecommerce">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
              <h4 className="mb-1">Activate Product For E-Com</h4>
              <Link to="/product-list" className="btn btn-primary btn-sm">
                <i className="bx bx-chevron-left bx-sm align-middle"></i> Back
              </Link>
            </div>
            <form onSubmit={handleSubmit(formHandleSubmit)}>
              <div className="row">
                <div className="col-12 col-lg-8">
                  <div className="card mb-4">
                    <div className="card-header d-flex justify-content-between">
                      <h5 className="card-tile mb-0">Product information</h5>
                    </div>
                    <div className="card-body">
                      <div className="row mb-3">
                        <div className="col">
                          <label className="form-label">
                            Barcode <small className={"text-danger"}>*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-barcode"
                            placeholder="0123-4567"
                            {...register("barcode")}
                            required={true}
                          />
                        </div>
                      </div>

                      <div>
                        <label className="form-label">
                          Description <small className={"text-danger"}>*</small>
                        </label>
                        <MyEditor
                          initialValue={editorData}
                          onChange={handleEditorChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="card mb-4">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <label className="form-label">
                        Upload Image <small className={"text-danger"}>*</small>
                      </label>
                      <GalleryModal
                        image={image}
                        setImage={setImage}
                        setSearch={setSearch}
                        search={search}
                      />
                    </div>
                    <div className="card-body">
                      <UploadImage images={images} setImages={setImages} />
                      <div className={"d-flex"}>
                        {image.map((img: any, index: number) => {
                          return (
                            <div className="image-preview" key={index}>
                              <div className="image-item">
                                <img src={img.image} alt={img.name} />
                                <br />
                                <button
                                  onClick={() => removeImage(img.id)}
                                  type={"button"}
                                  className="btn btn-danger btn-sm image-item-remove"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  <div className="card mb-4">
                    <div className="card-body">
                      <label className="form-label">
                        Product Specification &nbsp;
                        <span className="text-muted">(Optional)</span>
                      </label>
                      <ProductSpecificationEditor
                        initialValue={specification}
                        onChange={handleProductSpeciEditorChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="card mb-4">
                    <div className="card-header">
                      <h5 className="card-title mb-0">Pricing</h5>
                    </div>
                    <div className="card-body">
                      <div className="mb-3">
                        <label className="form-label">
                          Landing Cost
                          <small className={"text-danger"}>*</small>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="ecommerce-product-discount-price"
                          placeholder="Landing Cost"
                          {...register("selling_price")}
                          required={true}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          HSN Code <small className={"text-danger"}>*</small>
                        </label>

                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={hsnList}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="card mb-4">
                    <div className="card-header">
                      <h5 className="card-title mb-0">Organize</h5>
                    </div>
                    <div className="card-body">
                      <div className="mb-3 col ecommerce-select2-dropdown">
                        <label className="form-label mb-1">
                          Category <small className={"text-danger"}>*</small>
                        </label>
                        <select
                          id="vendor"
                          className="select2 form-select"
                          {...register("category_id")}
                          value={selectedCategory || ""}
                          onChange={handleCategoryChange}
                          required={true}
                        >
                          <option value="" disabled>
                            Select Category
                          </option>
                          {categoryList &&
                            categoryList.map((catList: any) => (
                              <option key={catList.id} value={catList.id}>
                                {catList.name}
                              </option>
                            ))}
                          ;
                        </select>
                      </div>

                      <div className="mb-3 col ecommerce-select2-dropdown">
                        <label className="form-label mb-1">Sub-Category</label>
                        <select
                          id="vendor"
                          className="select2 form-select"
                          {...register("sub_category_id")}
                          value={selectedSubcategory || ""}
                          onChange={handleSubcategoryChange}
                        >
                          <option value="" disabled>
                            Select Sub-Category
                          </option>
                          {subCategoryList &&
                            subCategoryList.map((subCatList: any) => (
                              <option key={subCatList.id} value={subCatList.id}>
                                {subCatList.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="mb-3 col ecommerce-select2-dropdown">
                        <label className="form-label mb-1">
                          Child-Category
                        </label>
                        <select
                          id="vendor"
                          className="select2 form-select"
                          {...register("child_category_id")}
                        >
                          <option value="">Select Child-Category</option>
                          {childCategoryList &&
                            childCategoryList.map((childCatList: any) => (
                              <option
                                key={childCatList.id}
                                value={childCatList.id}
                              >
                                {childCatList.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="mb-3 col ecommerce-select2-dropdown">
                        <label className="form-label mb-1">
                          Status <small className={"text-danger"}>*</small>
                        </label>
                        <select
                          id="status-org"
                          className="select2 form-select"
                          {...register("status")}
                          required={true}
                        >
                          <option value="" selected disabled>
                            Select Status
                          </option>
                          <option value="ACTIVATE">Active</option>
                          <option value="DEACTIVATE">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={isLoader}
              >
                {isLoader ? <i className={"fa fa-spinner fa-spin"}></i> : ""}
                &nbsp; Save Product
              </button>
            </form>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default ActivateEcomProduct;
